import { createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import reducers, { State, defaultState } from '../modules';

export type RootState = State;

export default (initialState: RootState = defaultState) => {
  return createStore<RootState, any, {}, {}>(reducers, initialState, composeWithDevTools());
};
